export const getTotalAndCheckItemNumber = (allData: any[]) => {
  let totalDocNumber = 0
  let docNumberToCheck = 0
  allData.forEach((item) => {
    item.fields.forEach((field: any) => {
      totalDocNumber++
      if (field.status === 'unverified') {
        docNumberToCheck++
      }
    })
  })
  return { totalDocNumber, docNumberToCheck }
}
